import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'sa_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] w-[360px] max-w-[calc(100vw-2rem)] bg-white rounded-2xl shadow-[0_8px_40px_rgba(0,0,0,0.18)] border border-gray-200 overflow-hidden">

      {/* Coloured top accent */}
      <div className="h-1 w-full bg-gradient-to-r from-purple-500 to-pink-500" />

      <div className="px-5 py-5 flex flex-col gap-4">

        {/* Heading */}
        <div>
          <p className="text-sm font-semibold text-gray-900 mb-1">We use cookies</p>
          <p className="text-sm text-gray-500 leading-relaxed">
            Stray Apps uses cookies to improve your experience and analyse traffic.
            By continuing you consent to our use of cookies.
          </p>
        </div>

        {/* Expanded details */}
        {expanded && (
          <div className="space-y-2 text-xs text-gray-500 leading-relaxed border-t border-gray-100 pt-3">
            <p><span className="font-semibold text-gray-700">Essential</span> — always active, required for core functionality.</p>
            <p><span className="font-semibold text-gray-700">Analytics</span> — Google Analytics, anonymised page-view tracking.</p>
            <p><span className="font-semibold text-gray-700">Preferences</span> — remember your settings and session state.</p>
          </div>
        )}

        {/* Actions */}
        <div className="flex flex-col gap-2">
          <button
            onClick={accept}
            className="w-full py-2.5 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-semibold hover:from-purple-600 hover:to-pink-600 transition-colors cursor-pointer shadow-[0_2px_10px_rgba(168,85,247,0.35)]"
          >
            Accept All
          </button>

          <div className="flex gap-2">
            <button
              onClick={() => setExpanded(v => !v)}
              className="flex-1 py-2 rounded-xl border border-gray-200 text-gray-600 text-xs font-medium hover:border-gray-300 hover:bg-gray-50 transition-colors bg-transparent cursor-pointer"
            >
              {expanded ? 'Hide details' : 'Manage Preferences'}
            </button>

            {expanded && (
              <button
                onClick={decline}
                className="flex-1 py-2 rounded-xl border border-gray-200 text-gray-600 text-xs font-medium hover:border-gray-300 hover:bg-gray-50 transition-colors bg-transparent cursor-pointer"
              >
                Decline
              </button>
            )}

            <Link
              to="/privacy-policy"
              className="flex-1 py-2 rounded-xl border border-gray-200 text-gray-600 text-xs font-medium hover:border-gray-300 hover:bg-gray-50 transition-colors no-underline text-center"
            >
              Privacy Policy
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
}
